import { createContext } from "react";

export const ReplyContext = createContext({});
